import { SearchScope } from '../../../store/search/state';
import { matchPath } from 'react-router';
import {
    SCOPE_ALL_OBJECT,
    SCOPE_CATALOGUE_OBJECT,
    SCOPE_EAUDIOBOOK_OBJECT,
    SCOPE_EBOOK_OBJECT,
    SCOPE_EPRESS_OBJECT,
    SCOPE_LANGUAGELEARNING_OBJECT,
    SCOPE_LOTE_OBJECT
} from '../../../store/search/actions';

export function deriveSearchScopeFromPathname(pathname: string): SearchScope | undefined {
    const catalogueMatch = matchPath<{ loanFormat: string }>(pathname, { path: '/catalogue/:loanFormat?' });
    if (catalogueMatch) {
        const loanFormat = catalogueMatch.params['loanFormat']?.toLowerCase();
        switch (loanFormat) {
            case 'ebooks':
                return SCOPE_EBOOK_OBJECT;
            case 'eaudiobooks':
                return SCOPE_EAUDIOBOOK_OBJECT;
            case 'emagazines':
            case 'epress':
                return SCOPE_EPRESS_OBJECT;
            default:
                return SCOPE_CATALOGUE_OBJECT;
        }
    }

    const libxMatch = matchPath(pathname, { path: ['/libxchange', '/shop/:shopLanguage/libxchange'] });
    if (libxMatch) {
        return SCOPE_CATALOGUE_OBJECT;
    }

    const loteMatch = matchPath(pathname, { path: '/language/lote' });
    if (loteMatch) {
        return SCOPE_LOTE_OBJECT;
    }

    const selectionListMatch = matchPath(pathname, { path: '/orderlists/:id' });
    if (selectionListMatch) {
        return SCOPE_CATALOGUE_OBJECT;
    }

    const languageLearningMatch = matchPath(pathname, {
        path: ['/language/languagelearning', '/shop/:shopLanguage/languagelearning']
    });
    if (languageLearningMatch) {
        return SCOPE_LANGUAGELEARNING_OBJECT;
    }

    const languageBundlesMatch = matchPath(pathname, { path: '/language/bundles' });
    if (languageBundlesMatch) {
        return SCOPE_CATALOGUE_OBJECT;
    }

    const collectionMatch = matchPath<{ loanFormat: string }>(pathname, { path: '/collection/:section/:loanFormat?' });
    const collectionMgmtMatch = matchPath<{ loanFormat: string }>(pathname, {
        path: '/collectionmgmt/:section/:loanFormat?'
    });
    if (collectionMatch || collectionMgmtMatch) {
        const loanFormat = collectionMatch
            ? collectionMatch.params['loanFormat']?.toLowerCase()
            : collectionMgmtMatch?.params['loanFormat']?.toLowerCase();
        switch (loanFormat) {
            case 'ebooks':
                return SCOPE_EBOOK_OBJECT;
            case 'eaudiobooks':
                return SCOPE_EAUDIOBOOK_OBJECT;
            case 'emagazines':
            case 'epress':
                return SCOPE_EPRESS_OBJECT;
            default:
                return SCOPE_ALL_OBJECT;
        }
    }

    const localContentMatch = matchPath<{ loanFormat: string }>(pathname, { path: '/localcontent' });
    if (localContentMatch) {
        const loanFormat = localContentMatch.params['loanFormat']?.toLowerCase();
        switch (loanFormat) {
            case 'ebooks':
                return SCOPE_EBOOK_OBJECT;
            case 'eaudiobooks':
                return SCOPE_EAUDIOBOOK_OBJECT;
            case 'emagazines':
            case 'epress':
                return SCOPE_EPRESS_OBJECT;
            default:
                return SCOPE_ALL_OBJECT;
        }
    }

    const campaignsMatch = matchPath<{ loanFormat: string }>(pathname, { path: '/marketing/campaigns/:loanFormat?' });
    if (campaignsMatch) {
        const loanFormat = campaignsMatch.params['loanFormat']?.toLowerCase();
        switch (loanFormat) {
            case 'ebooks':
                return SCOPE_EBOOK_OBJECT;
            case 'eaudiobooks':
                return SCOPE_EAUDIOBOOK_OBJECT;
            case 'emagazines':
            case 'epress':
                return SCOPE_EPRESS_OBJECT;
            default:
                return SCOPE_ALL_OBJECT;
        }
    }

    const marketingMatch = matchPath<{ loanFormat: string }>(pathname, { path: '/marketing' });
    if (marketingMatch) {
        return SCOPE_ALL_OBJECT;
    }

    const shopUnlimitedMatch = matchPath<{ loanFormat: string }>(pathname, {
        path: '/shop/:shopLanguage/unlimited/campaigns/:loanFormat'
    });
    if (shopUnlimitedMatch) {
        const loanFormat = shopUnlimitedMatch.params.loanFormat?.toLowerCase();
        switch (loanFormat) {
            case 'ebooks':
                return SCOPE_EBOOK_OBJECT;
            case 'eaudiobooks':
                return SCOPE_EAUDIOBOOK_OBJECT;
            case 'emagazines':
            case 'epress':
                return SCOPE_EPRESS_OBJECT;
            default:
                return SCOPE_CATALOGUE_OBJECT;
        }
    }

    const shopLoanFormatMatch = matchPath<{ loanFormat: string }>(pathname, {
        path: '/shop/:shopLanguage/:loanFormat'
    });
    if (shopLoanFormatMatch) {
        const loanFormat = shopLoanFormatMatch.params.loanFormat?.toLowerCase();
        switch (loanFormat) {
            case 'ebooks':
                return SCOPE_EBOOK_OBJECT;
            case 'eaudiobooks':
                return SCOPE_EAUDIOBOOK_OBJECT;
            case 'emagazines':
            case 'epress':
                return SCOPE_EPRESS_OBJECT;
            default:
                return SCOPE_CATALOGUE_OBJECT;
        }
    }

    return SCOPE_CATALOGUE_OBJECT;
}
